import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Address} from "../../../addresses/models/address.model";
import {getMandatoryKey} from "../../../orders/utils/identifications.util";

export class podItemsCtrl implements IController {

  identifications: any;
  isRow: any;
  canEdit: any;
  isShowAttachments: boolean;
  onEdit: Function;

  public items: any;
  public uneditableIdentifications: any;

  /* @ngInject */
  constructor(private tasksConstants) {
  }

  $onInit() {
    this.items = [];
    this.uneditableIdentifications = this.tasksConstants.uneditablePODs;

    if (_.get(this.identifications, 'photographIdCard')) {
      this.items.push({
        key: 'photographIdCard',
        text: 'Photo ID',
        blobName: this.identifications.photographIdCardBlobName,
        metadata: this.identifications.photographIdCardMetadata,
        link: this.identifications.photographIdCardUrl,
        isDone: !!this.identifications.photographIdCardDone,
        isMandatory: this._isMandatory('photographIdCard'),
        type: _.get(this.identifications, 'photographIdCardBlobName') ? (this.identifications.photographIdCardBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined
      });
    }

    if (_.get(this.identifications, 'photographPerson')) {
      this.items.push({
        key: 'photographPerson',
        text: 'Photo Person',
        blobName: this.identifications.photographPersonBlobName,
        metadata: this.identifications.photographPersonMetadata,
        link: this.identifications.photographPersonUrl,
        isDone: !!this.identifications.photographPersonDone,
        isMandatory: this._isMandatory('photographPerson'),
        type: _.get(this.identifications, 'photographPersonBlobName') ? (this.identifications.photographPersonBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined
      });
    }

    if (_.get(this.identifications, 'signature')) {
      this.items.push({
        key: 'signature',
        text: 'Signature',
        blobName: this.identifications.signatureBlobName,
        metadata: this.identifications.signatureMetadata,
        link: this.identifications.signatureUrl,
        isDone: !!this.identifications.signatureDone,
        isMandatory: this._isMandatory('signature'),
        type: _.get(this.identifications, 'signatureBlobName') ? (this.identifications.signatureBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined

      });
    }

    if (_.get(this.identifications, 'showIdCard')) {
      this.items.push({
        key: 'showIdCard',
        text: 'Show Id Card',
        metadata: this.identifications.showIdCardMetadata,
        isDone: !!this.identifications.showIdCardDone,
        isMandatory: this._isMandatory('showIdCard'),
        type: _.get(this.identifications, 'showIdCardBlobName') ? (this.identifications.showIdCardBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined
      });
    }

    if (_.get(this.identifications, 'leaveNextToDoor')) {
      this.items.push({
        key: 'leaveNextToDoor',
        text: 'leaveNextToDoor',
        blobName: this.identifications.photographLeaveNextToBlobName,
        metadata: this.identifications.photographLeaveNextToDoorMetadata,
        isDone: !!this.identifications.photographLeaveNextToDoorDone,
        isMandatory: this._isMandatory('leaveNextToDoor'),
        link: this.identifications.photographLeaveNextToDoorLink,
        type: _.get(this.identifications, 'photoLeaveNextToDoorBlobName') ? (this.identifications.leaveNextToDoorBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined
      });
    }
    if (_.get(this.identifications, 'validateIdCardNumber')) {
      this.items.push({
        key: 'validateIdCardNumber',
        text: 'validateIdCardNumber',
        metadata: this.identifications.validateIdCardMetadata,
        isDone: !!this.identifications.validateIdCardDone,
        isMandatory: this._isMandatory('validateIdCardNumber'),
        type: _.get(this.identifications, 'validateIdCardBlobName') ? (this.identifications.validateIdCardBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined
      });
    }
    if (_.get(this.identifications, 'validateAge')) {
      this.items.push({
        key: 'validateAge',
        text: 'validateAge',
        metadata: this.identifications.validateAgeMetadata,
        isDone: !!this.identifications.validateAgeDone,
        isMandatory: this._isMandatory('validateAge'),
        type: _.get(this.identifications, 'validateAgeBlobName') ? (this.identifications.validateAgeBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined
      });
    }
    if (_.get(this.identifications, 'visitSummary')) {
      this.items.push({
        key: 'visitSummary',
        text: 'visitSummary',
        blobName: this.identifications.visitSummaryBlobName,
        metadata: this.identifications.visitSummaryMetadata,
        link: this.identifications.visitSummaryUrl,
        isDone: !!this.identifications.visitSummaryDone,
        isMandatory: this._isMandatory('visitSummary'),
        type: _.get(this.identifications, 'visitSummaryBlobName') ? (this.identifications.visitSummaryBlobName.includes('.pdf') ? 'application/pdf' : undefined) : undefined

      });
    }
  }

  // Mandatory state for a POD lives on `is{PodKey}FillRequired` in the same
  // mixed `identifications` object. The mandatory icon must only show when
  // the POD itself is selected, so the caller already filters by POD value.
  private _isMandatory(podKey: string): boolean {
    return !!_.get(this.identifications, getMandatoryKey(podKey));
  }

  $onChanges(changes) {
    if (changes.identifications && !changes.identifications.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('podItems', {
    bindings: {
      identifications: '<',
      isRow: '<',
      isShowAttachments: '<',
      canEdit: '<',
      onEdit: '&'
    },
    template: require('./pod-items.html').default,
    controller: podItemsCtrl
  });
